/* ============================================================
 * MC · Prueba social — interactividad
 * ============================================================
 * Tabs: cambiar panel activo al click
 * Videos: lazy-load del <video> al click en play
 * Mobile slider: dots dinámicos según posición de scroll
 * ============================================================ */

(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.mcPsInit === '1') return;
    section.dataset.mcPsInit = '1';

    initTabs(section);
    initVideos(section);
    initDotsSlider(section);
  }

  // Tabs ─────────────────────────────────────────────────
  function initTabs(section) {
    const tabs = section.querySelectorAll('[data-mc-ps-tab]');
    const panels = section.querySelectorAll('[data-mc-ps-panel]');
    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.mcPsTab;
        tabs.forEach((t) => {
          const isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach((p) => {
          const isActive = p.dataset.mcPsPanel === target;
          p.classList.toggle('is-active', isActive);
          if (isActive) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      });
    });
  }

  // Videos: lazy-load el <video> al hacer click en play ─
  function initVideos(section) {
    const cards = section.querySelectorAll('[data-mc-ps-video-card]');
    cards.forEach((card) => {
      const playBtn = card.querySelector('[data-mc-ps-video-src]');
      const videoEl = card.querySelector('[data-mc-ps-video-el]');
      if (!playBtn || !videoEl) return;

      playBtn.addEventListener('click', () => {
        const src = playBtn.dataset.mcPsVideoSrc;
        if (!src) return;

        // Pausar todos los demás videos primero (un solo video a la vez)
        section.querySelectorAll('[data-mc-ps-video-el]').forEach((v) => {
          if (v !== videoEl && !v.paused) v.pause();
        });
        section.querySelectorAll('[data-mc-ps-video-card]').forEach((c) => {
          if (c !== card) c.classList.remove('is-playing');
        });

        // Cargar src la primera vez
        if (!videoEl.src) {
          videoEl.src = src;
        }
        videoEl.removeAttribute('hidden');
        card.classList.add('is-playing');
        videoEl.play().catch(() => {
          // Si falla autoplay, mostrar controles para que el usuario lo dispare
          videoEl.controls = true;
        });
      });

      // Cuando termina, restaurar thumbnail y play button
      videoEl.addEventListener('ended', () => {
        videoEl.pause();
        videoEl.currentTime = 0;
        card.classList.remove('is-playing');
        videoEl.setAttribute('hidden', '');
      });

      // Si el usuario pausa manualmente, mantener el video visible
      // (no vuelve al thumb hasta que termina o se navega de slide)
    });
  }

  // Dots dinámicos según scroll del track (solo mobile) ─
  function initDotsSlider(section) {
    const wrap = section.querySelector('[data-mc-ps-videos]');
    if (!wrap) return;
    const track = wrap.querySelector('.mc-ps__videos-track');
    const dotsContainer = wrap.querySelector('[data-mc-ps-dots]');
    if (!track || !dotsContainer) return;

    const cards = track.querySelectorAll('.mc-ps__video-card');
    if (!cards.length) return;

    // Crear un dot por card
    cards.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mc-ps__videos-dot';
      dot.setAttribute('aria-label', 'Ir al video ' + (i + 1));
      if (i === 0) dot.classList.add('is-active');
      dot.addEventListener('click', () => {
        const target = cards[i];
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });
      dotsContainer.appendChild(dot);
    });

    // Actualizar dot activo según scroll
    const dots = dotsContainer.querySelectorAll('.mc-ps__videos-dot');
    let scrollTimer = null;
    track.addEventListener('scroll', () => {
      if (scrollTimer) cancelAnimationFrame(scrollTimer);
      scrollTimer = requestAnimationFrame(() => {
        const trackRect = track.getBoundingClientRect();
        let activeIdx = 0;
        let minDistance = Infinity;
        cards.forEach((card, i) => {
          const cardRect = card.getBoundingClientRect();
          const distance = Math.abs(cardRect.left - trackRect.left);
          if (distance < minDistance) {
            minDistance = distance;
            activeIdx = i;
          }
        });
        dots.forEach((d, i) => d.classList.toggle('is-active', i === activeIdx));
      });
    });
  }

  // Init ─────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('.mc-prueba-social').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init en theme editor cuando se rerendea la sección
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.mc-prueba-social')) {
      e.target.querySelectorAll('.mc-prueba-social').forEach(initSection);
    }
  });
})();
